import React from 'react';
import { DocumentIcon, TrashIcon } from '@heroicons/react/24/outline';
import { API_BASE_URL } from '../services/apiService';

const AttachmentList = ({ attachments = [], onAttachmentDelete, canDelete = false }) => {
  const handleDelete = (attachmentId) => {
    if (onAttachmentDelete) {
      onAttachmentDelete(attachmentId);
    }
  };

  if (!attachments || attachments.length === 0) {
    return (
      <div className="text-center py-4">
        <DocumentIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No attachments</h3>
        <p className="mt-1 text-sm text-gray-500">No files have been uploaded to this ticket.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-medium text-gray-900">Attachments ({attachments.length})</h3>
      <div className="space-y-2">
        {attachments.map((attachment) => (
          <div key={attachment.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <DocumentIcon className="h-5 w-5 text-gray-400" />
              <div>
                <p className="text-sm font-medium text-gray-900">{attachment.fileName}</p>
                <p className="text-xs text-gray-500">
                  {attachment.fileSize ? `${(attachment.fileSize / 1024 / 1024).toFixed(2)} MB` : 'Unknown size'}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <a
                href={`${API_BASE_URL}${attachment.downloadUrl}`}
                download={attachment.fileName}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                Download
              </a>
              {canDelete && (
                <button
                  onClick={() => handleDelete(attachment.id)}
                  className="text-red-600 hover:text-red-800"
                  title="Delete attachment"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttachmentList;
